// src/Terms.js
import React from 'react';
import { Link } from 'react-router-dom';

function Terms() {
  return (
    <div className="min-h-screen bg-white p-6 md:p-12 text-gray-800">
      <div className="max-w-4xl mx-auto bg-gray-50 shadow-lg rounded-lg p-8 relative">

        {/* Back to Login */}
        <div className="absolute top-4 left-4">
          <Link
            to="/login"
            className="text-sm text-blue-600 hover:text-blue-800 underline"
          >
            ← Back to Login
          </Link>
        </div>

        {/* Header */}
        <h1 className="text-3xl font-bold mb-4 text-center text-blue-700">Terms & Conditions</h1>
        <p className="text-sm text-gray-500 mb-6 text-center">Last updated on 23-04-2025 00:54:38</p>

        {/* Terms Content */}
        <div className="space-y-4 text-sm leading-6">
          <p>These Terms and Conditions, along with privacy policy or other terms (“Terms”) constitute a binding agreement by and between SANYAM KAPOOR, (“Website Owner” or “we” or “us” or “our”) and you (“you” or “your”) and relate to your use of our website, goods (as applicable) or services (as applicable) (collectively, “Services”).</p>
          <p>By using our website and availing the Services, you agree that you have read and accepted these Terms (including the Privacy Policy). We reserve the right to modify these Terms at any time and without assigning any reason. It is your responsibility to periodically review these Terms to stay informed of updates.</p>
          <p>The use of this website or availing of our Services is subject to the following terms of use:</p>
          <ul className="list-disc list-inside space-y-2">
            <li>You agree to provide true, accurate and complete information during and after registration, and are responsible for all acts through your account.</li>
            <li>We do not provide any warranty or guarantee on accuracy, timeliness, or suitability of any content or Services offered.</li>
            <li>Your use of the Services is solely at your own risk and discretion. You must independently assess their suitability.</li>
            <li>All content is proprietary and you cannot claim any IP rights or ownership.</li>
            <li>Unauthorized use may lead to action under applicable laws.</li>
            <li>You agree to pay for any Service you avail.</li>
            <li>Do not use the website for any unlawful or illegal activities.</li>
            <li>Third-party links will be governed by their respective policies.</li>
            <li>Service transactions are legally binding contracts with us.</li>
            <li>Refunds are eligible only if claimed in time as per policy.</li>
            <li>Force majeure events exempt both parties from liability.</li>
            <li>These Terms are governed by Indian laws. Jurisdiction is in Patiala, Punjab.</li>
            <li>All concerns must be communicated using the contact info provided on the website.</li>
          </ul>
        </div>
      </div>
    </div>
  );
}

export default Terms;
